export default function CSwitchDefault() {
  return <h2>C Switch Default</h2>;
}
